import React from 'react';
import { CandidateOpportunitiesConst } from '@axiom/const';
import { CondensedHeader, CondensedLarge } from '@axiom/ui';
import type { FullCandidateAccount } from '@axiom/validation';

export const MyBenchCardAvailability = ({
  candidate,
}: {
  candidate: FullCandidateAccount;
}) => {
  let text = 'Available full-time';
  const isEngaged =
    candidate.accountCandidateStatus ===
    CandidateOpportunitiesConst.CandidateStatuses.Engaged;

  if (isEngaged) {
    text =
      !candidate.weeklyAvailability || candidate.weeklyAvailability <= 0
        ? 'Not available for more work'
        : 'Available for more work';
  } else if (
    !candidate.weeklyAvailability ||
    candidate.weeklyAvailability === 0
  ) {
    text = 'Not available';
  } else if (candidate.weeklyAvailability < 40) {
    text = 'Available part time';
  }

  return (
    <>
      <CondensedLarge name="AVAILABILITY_STATUS">{text}</CondensedLarge>
      <CondensedHeader name="AVAILABILITY_HOURS">
        {candidate.weeklyAvailability} hours per week
      </CondensedHeader>
    </>
  );
};
